import Spinner from './spinner';

const Loader = ({ children, ...rest }) => {
  return (
    <div className='absolute inset-0 flex flex-row justify-center items-center z-50 bg-white opacity-75' {...rest}><Spinner />{children}</div>
  );
};

export default Loader;
